import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretRightLarge = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4.03546L16 12.0355L8 20.0355", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretRightLarge);
const Memo = memo(ForwardRef);
export default Memo;
